export const packColorConfig_primary = new Map([
    ["default", "var(--primary-blue)"],
    ["PF", "var(--primary-green)"],
    ["PFP", "var(--primary-orange)"],
])
export const packColorConfig_100 = new Map([
    ["default", "var(--blue-100)"],
    ["PF", "var(--green-100)"],
    ["PFP", "var(--orange-100)"],
])